import { BarChartRounded, CompareRounded, HomeWorkRounded, PeopleAltRounded } from '@mui/icons-material';
import { Box, styled } from '@mui/material';
import { BookmarkTypes } from 'src/model/bookmark';
import { CompanyStatus } from 'src/utils/constants/enum';

export const TABS_BOOKMARK: ITabSetting[] = [
  {
    key: BookmarkTypes.Company,
    label: 'Company Profile',
    icon: HomeWorkRounded,
    disable: false,
  },
  {
    key: BookmarkTypes.People,
    label: 'People Profile',
    icon: PeopleAltRounded,
    disable: false,
  },
  {
    key: BookmarkTypes.CompareCompany,
    label: 'Compare Company',
    icon: CompareRounded,
    disable: false,
  },
  {
    key: BookmarkTypes.TradeData,
    label: 'Trade Data',
    icon: BarChartRounded,
    disable: false,
  },
];

// Common Style WhiteBox use in multiple  tab
export const StyledWhiteBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  background: theme.palette.background.default,
}));

export const STATUS_COMPANY = [
  { value: CompanyStatus.All, label: 'All Status' },
  { value: CompanyStatus.Active, label: 'Active' },
  { value: CompanyStatus.Closed, label: 'Closed' },
  { value: CompanyStatus.Suspended, label: 'Suspended' },
  { value: CompanyStatus.Unknown, label: 'Unknown' },
];

export enum ContactFilter {
  HaveContact = 'have_contact',
  NoContact = 'no_contact',
}

export const CONTACT_FILTER = [
  { value: ContactFilter.HaveContact, label: 'Has Contact' },
  { value: ContactFilter.NoContact, label: 'No Contact' },
];
